<template>
    <div
        class="evaluation-register classic"
        :class="{ 'new-ad-register': showNewRegister }"
    >
        <component
            v-if="loadMap"
            :is="registerMapType"
            @mapLoad="mapLoad"
            :markerData="markerData"
            :address="address"
            :tools="showTools"
        ></component>
        <div class="form-wrap">
            <v-form
                class="reg-form"
                :onSubmit="registerSubmit"
                :onSuccess="registerSubmitSuccess"
                :onError="registerSumbitError"
                ref="form"
            >
                <div
                    class="title"
                    v-if="title"
                    v-html="formatFontSize(title, 18)"
                    style="font-family: var(--font-bold)"
                ></div>
                <div
                    class="desc"
                    v-if="subTitle"
                    v-html="formatFontSize(subTitle, 14)"
                ></div>
                <div class="basic-info">
                    <template v-if="!authData">
                        <div class="name">
                            <!--  full name pattern  -->
                            <v-input
                                v-if="nameType == 1"
                                class="input-box"
                                name="fullname"
                                type="text"
                                :placeholder="`${
                                    namePlaceholder ||
                                    $t('md-evaluation-banner.fullName')
                                } ${nameRequired ? '*' : ''}`"
                                :required="nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                            <!--  separate naming scheme  -->
                            <v-input
                                v-if="nameType == 2"
                                class="input-box split"
                                name="firstName"
                                type="text"
                                :placeholder="`${$t(
                                    'md-evaluation-banner.firstName'
                                )} ${nameRequired ? '*' : ''}`"
                                :required="nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                            <v-input
                                v-if="nameType == 2"
                                class="input-box"
                                name="lastName"
                                type="text"
                                :placeholder="`${$t(
                                    'md-evaluation-banner.lastName'
                                )} ${nameRequired ? '*' : ''}`"
                                :required="nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                        </div>
                        <div class="account">
                            <v-input
                                class="input-box"
                                name="email"
                                type="email"
                                required
                                :maxlength="40"
                                :validateConfig="emailValidate"
                                :placeholder="$t('md-evaluation-banner.email')"
                            ></v-input>
                        </div>
                    </template>
                    <template v-else>
                        <div class="name">
                            <v-input
                                name="fullname"
                                class="input-box"
                                type="text"
                                :placeholder="`Full Name ${
                                    nameRequired ? '*' : ''
                                }`"
                                :required="nameRequired || false"
                                :value="`${authData.firstName || ''} ${
                                    authData.lastName || ''
                                }`"
                                readonly
                            />
                        </div>
                        <div class="account">
                            <v-input
                                name="email"
                                class="input-box"
                                type="email"
                                :readonly="!!authData.email"
                                :value="authData.email"
                                required
                                :maxlength="40"
                                :validateConfig="emailValidate"
                                :placeholder="$t('md-evaluation-banner.email')"
                            />
                        </div>
                    </template>
                    <div class="phone">
                        <v-input
                            class="input-box"
                            name="phone"
                            type="tel"
                            :placeholder="`${$t(
                                'md-evaluation-banner.phone'
                            )} ${phoneRequired ? '*' : ''}`"
                            :required="phoneRequired"
                            :validateConfig="{
                                async: '/api-site/phoneValidate?phoneNumber={value}'
                            }"
                        ></v-input>
                    </div>
                </div>
                <Disclaimer
                    color="#a0a3af"
                    :disclaimerUniqId="disclaimerUniqId"
                    @updateChecked="checked => (disclaimerChecked = checked)"
                    :btnText="thirdParty ? $t('md-evaluation-banner.getMyHomeReport') : submitText"
                />
                <div
                    class="submit"
                    :class="{ disabled: disclaimerSubmitDisabled }"
                    :title="
                        disclaimerSubmitDisabled
                            ? $t('common:customDisclaimerTip')
                            : ''
                    "
                >
                    <input
                        :style="buttonStyle"
                        type="submit"
                        :value="
                            thirdParty
                                ? $t('md-evaluation-banner.getMyHomeReport')
                                : submitText
                        "
                    />
                </div>
                <p class="err-msg" v-if="registerErrorMsg || thirdPartErrorMsg">
                    {{ registerErrorMsg || thirdPartErrorMsg }}
                </p>
            </v-form>
            <!--  This field is only shown if place login is empty  v-if="showFacebook || showGoogle"-->
            <div class="social">
                <div v-if="extrahtml" v-html="extrahtml"></div>
                <div class="split">
                    <span class="line"></span>
                    <span class="text" v-if="facebook || google">{{
                        $t('md-evaluation-banner.orLoginWithSocial')
                    }}</span>
                    <span class="line"></span>
                </div>
                <ThirdBox
                    theme="evaluation-classic"
                    :enableFb="showFacebook"
                    :enableGoogle="showGoogle"
                    fbBtnText="Facebook"
                    googleBtnText="Gmail"
                    @auth="authCallback"
                    @resize="resizeCallback"
                >
                </ThirdBox>
            </div>
        </div>
    </div>
</template>

<script>
import commonMixin from '../evaluation-register';
export default {
    name: 'evaluation-register',
    mixins: [commonMixin]
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.evaluation-register.classic {
    z-index: 2;
    width: 800px;
    margin: 0 auto;
    position: relative;
    display: flex;
    overflow: hidden;
    &.new-ad-register{
        .social,
        .email-suggestion{
            display: none;
        }
    }
    .site-map {
        height: auto;
        flex: 1;
        .marker-pop {
            background-color: white;
            color: black;
            .pointer {
                border-top: 7px solid white;
            }
        }
    }
    .form-wrap {
        width: 400px;
        min-height: 410px;
        flex: none;
        background-color: #f5f6fa;
        font-size: 14px;
        padding: 30px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .reg-form {
            flex-shrink: 0;
            //  Prompt mailbox on the left
            .email-suggestion {
                text-align: left;
            }
            .title {
                font-family: var(--font-bold);
                font-size: 18px;
                line-height: 1.44;
                color: #4a4a60;
                text-align: center;
            }
            .desc {
                font-family: var(--font-normal);
                font-size: 14px;
                color: #8b93a7;
                text-align: center;
                margin: 6px 0;
                h2,
                h3 {
                    margin: 8px 0 0;
                }
            }
            .name,
            .account,
            .phone {
                position: relative;
                input:not([type='submit']) {
                    border: none;
                    background: white;
                    box-shadow: none;
                    padding: 10px;
                    margin-top: 15px;
                    width: 100%;
                    height: 36px;
                    font-size: 14px;
                }
                .checked {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    border-radius: 50%;
                    background-color: #00a266;
                    display: flex;
                    justify-content: center;
                    .iconfont {
                        color: #fff;
                        top: 0;
                    }
                }
                .iconfont {
                    color: #a0a3af;
                    position: absolute;
                    top: 20px;
                    font-size: 14px;
                }
                .icon-mail-solid {
                    font-size: 12px;
                }
            }
            .err-msg {
                font-size: 12px;
                color: #f76363;
                text-align: center;
                padding-top: 5px;
            }
            .submit {
                text-align: center;
                input[type='submit'] {
                    font-family: var(--mg-button-font);
                    font-size: 14px;
                    @include color-button();
                    width: 100%;
                    height: 36px;
                    line-height: 36px;
                    margin-top: 20px;
                }
                &.disabled {
                    position: relative;
                    cursor: not-allowed;
                    &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        background-color: rgba(255, 255, 255, 0.5);
                    }
                    input[type='submit'] {
                        pointer-events: none;
                    }
                }
            }
            .v-input.invalid {
                input {
                    border: 1px solid #fa3939;
                }
                .mg-error {
                    text-align: left;
                }
            }
        }
        .social {
            text-align: center;
            .split {
                font-size: 12px;
                color: #8b93a7;
                margin: 20px 0 20px;
                display: flex;
                .text {
                    margin: 0 10px;
                    flex-shrink: 0;
                    flex-grow: 0;
                }
                .line {
                    border-top: 2px solid #f3f4f5;
                    flex-grow: 1;
                    margin-top: 7px;
                }
            }
        }
    }
    @include media-800 {
        width: auto;
        flex-direction: column;
        .site-map {
            height: 125px;
            .marker-pop {
                padding: 0 15px;
            }
        }
        .form-wrap {
            width: 100%;
            padding: 17px 20px 33px;
        }
    }
}
</style>
